import * as React from 'react';
import { registerComponent, withProgressiveHydration } from '@avensia/excite';
import { styled } from '@glitz/react';
import Image from 'webapp/components/image';
import { ArrowRight } from 'webapp/components/icons';
import Price from 'nordicnest/product/Price';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';
import { Variant } from 'webapp/product/price-variant';
import { isSvenssons } from 'webapp/theme';
import Link from 'webapp/components/Link';

export default registerComponent<NordicNest.Api.InspirationProductImageBlockApiModel>(
  withProgressiveHydration(InspirationProductImageBlock),
);

function InspirationProductImageBlock(props: NordicNest.Api.InspirationProductImageBlockApiModel) {
  return (
    <Base>
      <Link to={props.product?.url} linkIdentifier={props.product?.ticket}>
        <Image image={props.image} />
        {props.product && (
          <BottomContent>
            <Text>
              <Brand>{props.product.brand}</Brand>
              <ProductName>{props.product.productName}</ProductName>
              {props.product.availableInCountry && (
                <ProductPrice price={props.product.price} variant={Variant.Compact} config={props.product.price} />
              )}
            </Text>
            <ArrowRight />
          </BottomContent>
        )}
      </Link>
    </Base>
  );
}

const Base = styled.div({
  cursor: 'pointer',
});

const BottomContent = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: t => (isSvenssons ? t.sharedSpacing.m : t.spacing.s),
});

const Text = styled.span(
  createMaxSmallViewportDecorator({
    fontSize: t => t.fontSize.xxs,
    paddingLeft: t => t.sharedSpacing.m,
  }),
  {
    fontSize: t => t.fontSize.xs,
    display: 'flex',
    alignItems: 'baseline',
  },
);

const Brand = styled.span({
  color: t => t.dark.color,
  marginRight: '1ch',
  fontSize: t => t.fontSize.xxs,
  textTransform: 'uppercase',
});

const ProductName = styled.span({
  marginRight: '1ch',
});

const ProductPrice = styled(Price, createMaxSmallViewportDecorator({ fontSize: t => t.fontSize.xxs }), {
  fontWeight: 'bold',
  fontSize: t => t.fontSize.xs,
});
